import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getTicketSummaryDetailsSlice = createApi(`GetTicketSummaryDetailsSlice`,"GET");

const GetTicketSummaryDetailsSlice = createSlice({
  name: 'GetTicketSummaryDetailsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTicketSummaryDetailsSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTicketSummaryDetailsSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getTicketSummaryDetailsSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetTicketSummaryDetailsSlice.reducer;